// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__367ur","truncatedText":"styles_truncatedText__o0XtX","fullText":"styles_fullText__H5nvj","textContainer":"styles_textContainer__0drur"};